import Button from '@material-ui/core/Button/Button';
import CircularProgress from '@material-ui/core/CircularProgress/CircularProgress';
import FormControl from '@material-ui/core/FormControl/FormControl';
import FormGroup from '@material-ui/core/FormGroup/FormGroup';
import FormHelperText from '@material-ui/core/FormHelperText/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel/FormLabel';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import Paper from '@material-ui/core/Paper/Paper';
import MaterialSelect from '@material-ui/core/Select/Select';
import TextField from '@material-ui/core/TextField/TextField';
import Typography from '@material-ui/core/Typography/Typography';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import { emphasize } from '@material-ui/core/styles/colorManipulator';
import DeleteIcon from '@material-ui/icons/Delete';
import Save from '@material-ui/icons/Save';
import * as React from "react";
import { ChangeEvent } from "react";
import { $enum } from "ts-enum-util";
import { PeopleRequestFactory } from "../../model/autogen/PeopleController";
import { PersonModel } from "../../model/autogen/PersonModel";
import { PersonType } from "../../model/autogen/PersonType";
import { BlockQuote } from "../material/block-quote";
import AddCircle from "../../../node_modules/@material-ui/icons/AddCircle";
import { UserLevel } from "../../model/autogen/UserLevel";
import { withEditorPage } from "../../pages/editor-page";
import { strIsNullOrEmpty } from "../../utils/string";
import { IAuthContextProps, withAuthContext } from "../with-auth-context";
import { ISnackbarContextProps, withSnackbar } from "../with-snackbar";
import { IContentForm } from "./icontent-form";
import Downshift, { ControllerStateAndHelpers } from '../../../node_modules/downshift';
import { QuotedSubjectModel } from '../../model/autogen/QuotedSubjectModel';
import { QuoteModel } from '../../model/autogen/QuoteModel';
import { Spacer } from '../utility-components';
import { Iif } from '../iif';
import { DefaultStyle } from '../../utils/createStyles';
import { TwitterHandleModel } from 'model/autogen/TwitterHandleModel';
import { InputAdornment } from '@material-ui/core';

//
//todo: this component contains a react-select component styled for material-ui, it should be pulled into its own component if
// anyone intends to reuse it.
export interface IPersonProps extends IContentForm<PersonModel> {
    
}

export interface IPeopleState extends PersonModel {
    isSaving: boolean;
    twitterError: string;
    facebookError: string;
    affiliationMessage: string;
    quotedReferences: QuoteModel[];
    cannotSaveQuotes: boolean;
}

const politicalParties = [
    { label: 'NA' },
    { label: 'Labour Party' },
    { label: 'National Party' },
    { label: 'Independent' },
    { label: 'NZ First' },
    { label: 'Green Party' },
    { label: 'ACT' },
    { label: 'Aotearoa Legalise Cannabis Party' },
    { label: 'New Conservative' },
    { label: 'Mana Party' },
    { label: 'Māori Party' },
    { label: 'New Zealand Democratic Party for Social Credit' },
    { label: "New Zealand People's Party" },
    { label: 'New Zealand Outdoors Party' },
    { label: 'NZ Climate Party' },
    { label: 'Communist League' },
    { label: 'GOdsownNZ' },
    { label: 'National Front' },
    { label: 'Not A Party' },
    { label: 'Pirate Party of New Zealand' },
    { label: 'Internet Party' },
    { label: 'Socialist Aotearoa' },
    { label: 'Seniors Party' },
    { label: 'Te Paati Maori'}
];

function renderInput(inputProps: any) {
    const { InputProps, classes, ref, ...other } = inputProps;

    return (
        <TextField
            InputProps={{
                inputRef: ref,
                classes: {
                    root: classes.inputRoot,
                },
                ...InputProps,
            }}
            {...other}
            contentEditable={false}

        />
    );
}

interface IRenderSuggestionOptions {
    highlightedIndex: number;
    index: number;
    itemProps: any;
    selectedItem: string;
    suggestion: { label: string };
}


function renderSuggestion({ suggestion, index, itemProps, highlightedIndex, selectedItem }: IRenderSuggestionOptions) {
    const isHighlighted = highlightedIndex === index;
    const isSelected = (selectedItem || '').indexOf(suggestion.label) > -1;

    return (
        <MenuItem
            {...itemProps}
            key={suggestion.label}
            selected={isHighlighted}
            component="div"
            style={{
                fontWeight: isSelected ? 500 : 400,
            }}
        >
            {suggestion.label}
        </MenuItem>
    );
}

type PersonStyle = DefaultStyle & {
    root: {
        flexGrow: string | number,
        height: string | number,
    },
    input: {
        display: 'flex',
        padding: string | number,
    },
    valueContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        flex: string | number,
        alignItems: 'center',
    },
    chip: {
        margin: string | number,
    },
    chipFocused: {
        backgroundColor: any
    },
    noOptionsMessage: {
        padding: string | number
    },
    singleValue: {
        fontSize: string | number,
    },
    placeholder: {
        position: 'absolute',
        left: string | number,
        fontSize: string | number,
    },
    paper: {
        marginTop: string | number
    },
    divider: {
        height: string | number
    },
    extendedIcon: {
        marginRight: string | number,
    },
}

const styles = (theme: any) => ({
    root: {
        flexGrow: 1,
        height: 250,
    },
    input: {
        display: 'flex',
        padding: 0,
    },
    valueContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        flex: 1,
        alignItems: 'center',
    },
    chip: {
        margin: `${theme.spacing.unit / 2}px ${theme.spacing.unit / 4}px`,
    },
    chipFocused: {
        backgroundColor: emphasize(
            theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
            0.08,
        ),
    },
    noOptionsMessage: {
        padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
    },
    singleValue: {
        fontSize: 16,
    },
    placeholder: {
        position: 'absolute',
        left: 2,
        fontSize: 16,
    },
    paper: {
        marginTop: theme.spacing.unit,
    },
    divider: {
        height: theme.spacing.unit * 2,
    },
    extendedIcon: {
        marginRight: theme.spacing.unit,
    },
});

type PersonFormComponentProps = IPersonProps & IAuthContextProps & ISnackbarContextProps & WithStyles<keyof PersonStyle>;

class PersonFormComponent extends React.Component<PersonFormComponentProps, IPeopleState> {
    constructor(props: PersonFormComponentProps) {
        super(props);
        this.count = 0;
        this.state = { isSaving: false, ...props.item, facebookError: "", twitterError: "", affiliationMessage: "", quotedReferences: [], cannotSaveQuotes: false, };
    }
    count: number = 0;

    componentDidMount = () => {
        let { quotes, cannotSaveQuotes } = this.state
        if (quotes.length < 1) {
            cannotSaveQuotes = false
        }
        this.setState({ cannotSaveQuotes,});
        
        
    }

    private onTextChange = (e: ChangeEvent<HTMLInputElement>) => {
        this.setState({ [e.target.name]: e.target.value } as any);
    }

    private onInputValueChange = (inputValue: string,
        stateAndHelpers: ControllerStateAndHelpers) => {
        this.setState({ partyAffiliation: inputValue });
    }

    private onSave = async (e: any) => {
        const { isSaving, ...payload } = this.state;
        const { callApi, showSnackbarMessage } = this.props;

        const missingQuotes = payload.quotes.filter(q => strIsNullOrEmpty(q.phrase));
        if (missingQuotes.length > 0) {
            alert(`${missingQuotes.length} quote(s) have missing quote content. Add this missing quote content or remove said quotes and try again.`);
            return;
        }

        this.setState({ isSaving: true });
        try {
            const result = await callApi((fetcher) => (payload.id > 0 ? PeopleRequestFactory.update : PeopleRequestFactory.create)(fetcher, payload));
            if (this.props.user.level <= UserLevel.External) {
                showSnackbarMessage("Your content has been successfully submitted. It will be reviewed and posted by a Research Hub editor.Any questions, email researchhub@labour.org.nz");
                
            }
            else {
                showSnackbarMessage(payload.id > 0 ? 'Person Saved' : `New Person saved (${result.documentId})`);
            }
            this.props.onSaveCompleted();
        } catch (e) {
            showSnackbarMessage(`Error saving Person: ${(e.body || {}).message || "Error not specified"}`);
            this.setState({ isSaving: false });
        }
    }


    private onPersonTypeChange = (e: any) => {
        const canHaveAffiliation = e.target.value != PersonType.Journalist;
        this.setState({
            personType: parseInt(e.target.value, 10), partyAffiliation: canHaveAffiliation ? this.state.partyAffiliation : "NA",
            affiliationMessage: canHaveAffiliation ? "" : "Journalists cannot have party affiliation"
        });
    }

    deleteQuote = (quoteIdx: number) => {
        var { quotes } = this.state;
        quotes.splice(quoteIdx, 1);
        this.setState({ quotes });
    }

    addQuote = () => {
        var { quotes, cannotSaveQuotes } = this.state;
        quotes.push({
            id: --this.count,
            topic: "",
            phrase: "",
            subjects: [],
            person: {} as PersonModel,
            assignFiles: [],
            files: [],
            dateOfQuote: new Date(),
            sourceURL: "",
            tags: [],
            createTags: [],
            type: 'Quotes',
            date: new Date(),
            title: "",
            author: ""
        });
        cannotSaveQuotes = true
        this.setState({ quotes, cannotSaveQuotes });
    }

    addAnotherQuote = () => {
        var { quotes, cannotSaveQuotes } = this.state;
        var previousQuote = quotes[(quotes.length - 1)]
        quotes.push({
            id: --this.count,
            topic: previousQuote.topic,
            phrase: "",
            subjects: previousQuote.subjects,
            person: previousQuote.person,
            assignFiles: [],
            files: previousQuote.files,
            dateOfQuote: previousQuote.dateOfQuote,
            sourceURL: previousQuote.sourceURL,
            tags: previousQuote.tags,
            createTags: [],
            type: 'Quotes',
            date: new Date(),
            title: "",
            author: ""
        });
        cannotSaveQuotes = true
        this.setState({ quotes, cannotSaveQuotes });
    }
    
    private onPeopleChanged = (quoteIdx: number, people: PersonModel[]) => {
        var { quotes } = this.state;
        quotes[quoteIdx].subjects = people.map(p => {
            return {
                id: -1,
                subject: {
                    id: p.id,
                    firstName: p.firstName,
                    lastName: p.lastName
                }
            } as QuotedSubjectModel;
        })

        this.setState({ quotes });
    }

    private onTwitterHandlesChange = (e: ChangeEvent<HTMLInputElement>) => {
        var { twitterHandles } = this.state;
        if (twitterHandles.length === 0) {
            twitterHandles.push({displayName: e.target.value} as TwitterHandleModel)
        } else {
            twitterHandles[0].displayName = e.target.value;
        }
        this.setState({ twitterHandles })
    }

    partyAffiliationChanged = (selectedOption: any) => {
        this.setState({ partyAffiliation: selectedOption });
    }

    private onFaceBookChange = (e: ChangeEvent<HTMLInputElement>) => {
        const isUrl = require('is-url');
        if (e.target.value == "") {
            this.setState({ facebookError: "" });
        }
        else if (!isUrl(e.target.value)) {
            this.setState({ facebookError: "Need to have a URL" });
        }
        else if (e.target.value.indexOf("fb.com") < 0 && e.target.value.indexOf("facebook.com") < 0) {
            this.setState({ facebookError: "Not a facebook link" });
        }
        else {
            this.setState({ facebookError: "" });
        }

        this.onTextChange(e);
    }

    getSuggestions(inputValue: string) {
        let count = 0;

        return politicalParties.filter(party => {
            const keep =
                (!inputValue || party.label.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1) &&
                count < 5;

            if (keep) {
                count += 1;
            }

            return keep;
        });
    }

    public cannotSave = () => {
        let { quotes, cannotSaveQuotes } = this.state
        cannotSaveQuotes = quotes.filter(quote => {
            return ((!quote.assignFiles) && quote.sourceURL === "") || quote.phrase === ""
        }).length === 0 ? false : true
        this.setState({cannotSaveQuotes})
    }


    private expanded = (index: number) => {
        const { quotes } = this.state
        // Expansion panel default is collapsed so only expand if true
        return index ===  quotes.length - 1? true : undefined
    }
    public render(): JSX.Element {
        const { partyAffiliation, personType, facebook, firstName, lastName, twitterHandles, isSaving, cannotSaveQuotes } = this.state;
        let { quotes } = this.state
        const { classes } = this.props;
        quotes = quotes.sort((a,b) => {
            const aDateStr = `${a.dateOfQuote}`;
            const bDateStr = `${b.dateOfQuote}`;
            return aDateStr.localeCompare(bDateStr)
        })
        const canSelectPartyAffiliation = (personType !== PersonType.Journalist);

        const subTypeEnumValues = $enum(PersonType);
        const cannotSave = isSaving || !strIsNullOrEmpty(this.state.facebookError) || !strIsNullOrEmpty(this.state.twitterError) || cannotSaveQuotes;// || strIsNullOrEmpty(answer) || strIsNullOrEmpty(title);
        return <div><FormControl component={"fieldset" as "div"} fullWidth={true}>
            <Typography variant="h5">{!this.props.item.id ? 'New' : ''} Person Details</Typography>
            <FormGroup>
                <FormControl>
                    <FormLabel>First Name</FormLabel>
                    <TextField name="firstName" value={firstName} onChange={this.onTextChange} />
                </FormControl>
                <div className={classes.divider} />

                <FormControl>
                    <FormLabel>Last Name</FormLabel>
                    <TextField name="lastName" value={lastName} onChange={this.onTextChange} />
                </FormControl>
                <div className={classes.divider} />

                <FormControl>
                    <FormLabel>Twitter Handle</FormLabel>
                    <TextField  name="twitterHandles" value={twitterHandles.length > 0 ? twitterHandles[0].displayName : ""} onChange={this.onTwitterHandlesChange} InputProps={{ startAdornment: <InputAdornment position="start">@</InputAdornment>,
                    }} />
                </FormControl>
                <div className={classes.divider} />

                <FormControl>
                    <FormLabel>Facebook</FormLabel>
                    <TextField error={this.state.facebookError !== ''} name="facebook" value={facebook} onChange={this.onFaceBookChange} />
                    <FormHelperText id="facebook">{this.state.facebookError}</FormHelperText>
                </FormControl>
                <div className={classes.divider} />

                <FormControl>
                    <FormLabel>Type</FormLabel>
                    <MaterialSelect value={personType} onChange={this.onPersonTypeChange}>
                        {subTypeEnumValues.map(a => <MenuItem key={a} value={a}>{subTypeEnumValues.getKeyOrDefault(a)}</MenuItem>)}
                    </MaterialSelect>
                </FormControl>
                <div className={classes.divider} />

                <FormControl>
                    <FormLabel>Party Affiliation</FormLabel>

                    <Downshift defaultInputValue="" inputValue={partyAffiliation} onInputValueChange={this.onInputValueChange} onChange={this.partyAffiliationChanged} id="downshift-simple">
                        {({ getInputProps, getItemProps, isOpen, inputValue, selectedItem, highlightedIndex }: any) => (
                            <div className={classes.container}>
                                {renderInput({
                                    fullWidth: true,
                                    classes,
                                    InputProps: getInputProps({
                                        name: "affiliation",
                                        placeholder: 'Input party affiliation',
                                        disabled: !canSelectPartyAffiliation
                                    }),
                                })}
                                {isOpen ? (
                                    <Paper className={classes.paper} square>
                                        {this.getSuggestions(inputValue).map((suggestion, index) =>
                                            renderSuggestion(
                                                {
                                                    suggestion: suggestion,
                                                    index: index,
                                                    itemProps: getItemProps({ item: suggestion.label }),
                                                    highlightedIndex: highlightedIndex,
                                                    selectedItem: selectedItem
                                                }
                                            ),
                                        )}
                                    </Paper>
                                ) : null}
                            </div>
                        )}
                    </Downshift>


                </FormControl>
                <FormHelperText id="affiliation">{this.state.affiliationMessage}</FormHelperText>
                <br />
                <h3>Quoted Saying<Button style={{ float: 'right' }} variant="extendedFab" onClick={this.addQuote}><AddCircle className={classes.extendedIcon} />Add Quote</Button></h3>
                {quotes.map((x, i) => {
                    return <BlockQuote 
                        onPeopleChanged={(people: PersonModel[]) => this.onPeopleChanged(i, people)}
                        customDecoration={
                            <Button onClick={() => this.deleteQuote(i)}
                                style={{ width: '50px', height: '50px'}}
                                variant="fab" color="secondary" aria-label="Delete">
                                <DeleteIcon />
                            </Button>}
                        edit={true}
                        cannotSave={this.cannotSave}
                        key={quotes[i].id}
                        quote={x}
                        expanded={this.expanded(i)} />
                }).reverse()}

                <Iif show={this.state.quotes.length > 0 }>
                    <div style={{display: "flex", justifyContent: "space-around"}}>
                        <Button style={ {width: "35%", height: 'auto', margin: '10px' }} variant="extendedFab" onClick={this.addQuote}><AddCircle className={classes.extendedIcon} />Additional Quote </Button>
                        <Button style={ {width: "35%", height: 'auto', margin: '10px' }} variant="extendedFab" onClick={this.addAnotherQuote}><AddCircle className={classes.extendedIcon} />Duplicate Most Recent Quote </Button>
                    </div>
                </Iif>
                <Spacer />
                <Button variant="contained" fullWidth={true} onClick={this.onSave} disabled={isSaving || cannotSave} color="primary">
                    {isSaving ? <CircularProgress size={24} /> : <Save />}{isSaving ? " Saving ..." : " Save"}
                </Button>
            </FormGroup>
        </FormControl></div>;
    }
}

// HACK: wrapper to workaround the fact that our current codegen doesn't support argument default values, so there's a signature mismatch
const personGet = (fetcher: (url: string, init: RequestInit) => Promise<Response>, id: number) => PeopleRequestFactory.getById(fetcher, id, false);

const PersonStyle = withStyles(styles as any, { withTheme: true })(PersonFormComponent) as React.ComponentType<PersonFormComponentProps>;
export const PersonForm = withSnackbar(withAuthContext(PersonStyle, UserLevel.SystemUser)) as React.ComponentType<IPersonProps>;

export const PersonEditPage = withAuthContext(withEditorPage(PersonForm as any, personGet), UserLevel.SystemUser) as React.ComponentType<IPersonProps>;


// WEBPACK FOOTER //
// ./src/components/forms/person.tsx